import React, { ReactElement } from 'react';

import { Paragraph } from '@pb/shared/ui/atoms/paragraph';
import { Link } from '@pb/shared/ui/atoms/link';
import { Icon } from '@pb/shared/ui/atoms/icon';
import { getEnvironmentSettings } from '@pb/services';
import {
    TNotificationListHeader,
    TNotificationListProperties,
    TNavigationItems,
} from './notification-list.types';
import {
    StyledLabelSpan,
    StyledLiLabelWrapper,
    StyledMobileArrowIconSpan,
    StyledNotificationDivWrapper,
    StyledNotificationsUlContainer,
    StyledNotificationArea,
    StyledNoNotificationsWrapper,
    StyledNotifications,
    StyledNotification,
} from './notification-list.styled';

function NotificationListHeader({
    onClose,
}: TNotificationListHeader): ReactElement {
    return (
        <StyledLiLabelWrapper>
            <StyledMobileArrowIconSpan onClick={onClose}>
                <Icon
                    type="removeOrClose"
                    color="black"
                    aria-label="Close the notification drop down"
                />
            </StyledMobileArrowIconSpan>
            <StyledLabelSpan>Notifications</StyledLabelSpan>
        </StyledLiLabelWrapper>
    );
}

function NavigationItems({
    notificationItems,
}: TNavigationItems): ReactElement {
    return (
        <StyledNotifications>
            {notificationItems.map((notification, index) => (
                <StyledNotification
                    aria-label="Click to navigate to your notification"
                    key={`${notification.type}-${index}`}
                >
                    <Link to={notification.url}>
                        <StyledNotificationArea>
                            {notification.area}
                        </StyledNotificationArea>
                        {notification.copy}
                    </Link>
                </StyledNotification>
            ))}
        </StyledNotifications>
    );
}

function NoNotifications() {
    const { onlineAssestsUrl } = getEnvironmentSettings();
    return (
        <StyledNoNotificationsWrapper>
            <img
                src={`${onlineAssestsUrl}/Nx/notification-illustration-message.svg`}
                alt="No notifications available"
            />
            <Paragraph align="center">
                It looks like you don't have any notifications at the moment.
            </Paragraph>
        </StyledNoNotificationsWrapper>
    );
}

export function NotificationList({
    onClose,
    reference,
    notificationItems,
}: TNotificationListProperties): ReactElement {
    return (
        <StyledNotificationDivWrapper ref={reference}>
            <StyledNotificationsUlContainer>
                <NotificationListHeader onClose={onClose} />
                {notificationItems &&
                    (notificationItems.length > 0 ? (
                        <NavigationItems
                            notificationItems={notificationItems}
                        />
                    ) : (
                        <NoNotifications />
                    ))}
            </StyledNotificationsUlContainer>
        </StyledNotificationDivWrapper>
    );
}
